<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { wsClient } from '@/net/WebSocketClient'
import { MsgIDs } from '@/defines/MsgIDs'
import { Client2ProxyReqLogin, Client2ProxyAckLogin } from '@/proto/proto.js'

const router = useRouter()

const handleLoginAck = (payload: Uint8Array) => {
  const rsp = Client2ProxyAckLogin.decode(payload)
  console.log('[Net StartView] Client2ProxyAckLogin:', rsp)
  if (rsp.Ret === 0) {
    // 登录成功，跳转到大厅
    localStorage.setItem('hasEnteredLobby', 'true')
    router.push('/home')
  } else {
    alert(`Guest Login Failed: Error Code ${rsp.Ret}`)
  }
}

onMounted(() => {
  wsClient.connect()
  wsClient.on(MsgIDs.Client2ProxyAckLogin, handleLoginAck)
})

onUnmounted(() => {
  wsClient.off(MsgIDs.Client2ProxyAckLogin, handleLoginAck)
})

const handleGuestLogin = () => {
  // Origin 1 代表游客登录
  const req = Client2ProxyReqLogin.create({
    Origin: 1,
    ClientMark: 'guest_web_client',
    platformType: 3,
    version: '1.0.0'
  })
  const payload = Client2ProxyReqLogin.encode(req).finish()

  if (wsClient.send(MsgIDs.Client2ProxyReqLogin, payload)) {
    console.log('[Net StartView] Sending Guest Login Req')
  }
}
</script>

<template>
  <div class="start-container">
    <div class="content-wrapper">
      <div class="action-section">
        <button class="btn-golden" @click="handleGuestLogin">
          <span class="btn-text">کلک بڑا جیتو!</span>
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.start-container {
  min-height: 100vh;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end; /* Push button towards the bottom */
  overflow: hidden;
  background-color: #000;
  background-image: url('@/assets/vegas-bg.png');
  background-size: 100% 100%; /* Full screen adaptation (Stretch to fit) */
  background-position: center;
  background-repeat: no-repeat;
}

.content-wrapper {
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  height: 100vh;
  width: 100%;
  padding-bottom: 12vh; /* Position the button properly */
}

.action-section {
  margin-bottom: 5vh;
}

/* Golden Button Style */
.btn-golden {
  background: linear-gradient(to bottom, #ffe494 0%, #e2b02e 40%, #c48c14 60%, #ffeaa8 100%);
  border: 2px solid #fff2c4;
  border-radius: 50px;
  padding: 12px 60px;
  text-align: center;
  cursor: pointer;
  box-shadow: 
    0px 5px 15px rgba(0, 0, 0, 0.6),
    inset 0 0 10px rgba(255, 255, 255, 0.7);
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
}

.btn-golden::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 50%;
  height: 100%;
  background: linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,0.8) 50%, rgba(255,255,255,0) 100%);
  transform: skewX(-25deg);
  animation: shine 3s infinite;
}

@keyframes shine {
  0% { left: -100%; }
  20% { left: 200%; }
  100% { left: 200%; }
}

.btn-golden:hover {
  transform: scale(1.05);
  box-shadow: 
    0px 8px 20px rgba(0, 0, 0, 0.7),
    inset 0 0 15px rgba(255, 255, 255, 0.9);
}

.btn-golden:active {
  transform: scale(0.98);
}

.btn-text {
  font-family: inherit;
  font-weight: 800;
  font-size: 1.4rem;
  color: #3f1900;
  text-shadow: 0px 1px 1px rgba(255, 255, 255, 0.5);
  letter-spacing: 1px;
}
</style>
